
import './Background.css';

export const Background = () => {
  return <div className="bg-container">
  <div className="bg1" />
  <div className="bg2" />
</div>;
}